function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.045 8.92l.943.943-1.414 1.414A3.333 3.333 0 111.86 6.563L3.274 5.15l.943.943-1.414 1.414a2 2 0 102.828 2.829L7.045 8.92zM6.103 4.206l-.943-.942 1.414-1.415a3.333 3.333 0 114.714 4.714L9.874 7.978l-.943-.943 1.414-1.414a2 2 0 10-2.828-2.829L6.103 4.206z",
  fill: "#08F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.46 3.735L3.746 8.449l.942.943 4.714-4.714-.942-.943z",
  fill: "#08F"
});

function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgLinkIcon;